import axios from '@axios'

export const state = {
  smpp: [],
}

export const getters = {
  allSmpp: (state) => state.smpp,
}

export const mutations = {
  GET_SMPP: (state, data) => {
    state.smpp = data
  },
}

export const actions = {
  async getSmpp({ commit }, id) {
    await axios
      .get(`/users/${id}/smpp`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_SMPP', resp.data)
        } else {
          commit('GET_SMPP', { pwd: 'none', uid: 'none' })
        }
      })
      .catch(() => {
        commit('GET_SMPP', { pwd: 'none', uid: 'none' })
      })
  },
}
